import React from 'react'
import locationsMetadata from './locationsData';
import { Link, Redirect } from 'react-router-dom'
import Helmet from 'react-helmet'
import LocationsView from './LocationsView';
import { siteData } from './locationsData';
import RestaurantMap from './ReataurantMap';

export default function () {
  return (
    <div id="promo-page" role="main" aria-labelledby="promotion-header">
      <Helmet>
        <title>{siteData.shortName} | 5% Cashback on All Orders</title>
      </Helmet>

      <style>{`
        #promo-page {
          background-color: #ffffff;
          color: #333333;
          min-height: 100vh;
        }
        
        .promotion-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          text-align: center;
        }
        
        .promotion-header {
          background: linear-gradient(135deg, maroon, #d80101ff);
          color: white;
          padding: 40px 20px;
          border-radius: 15px;
          margin-bottom: 30px;
        }
        
        .promotion-title {
          font-size: 3em;
          font-weight: bold;
          margin-bottom: 10px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
        }
        
        .promotion-subtitle {
          font-size: 1.5em;
          margin-bottom: 20px;
        }
        
        .promotion-details {
          background: #f8f8f8;
          padding: 30px;
          border-radius: 15px;
          margin: 30px 0;
          border: 1px solid #e0e0e0;
        }
        
        .offer-text {
          font-size: 2em;
          color: maroon;
          font-weight: bold;
          margin-bottom: 15px;
        }
        
        .terms {
          font-size: 1.1em;
          color: #555555;
          line-height: 1.6;
          margin: 20px 0;
        }
        
        .cta-button {
          background: linear-gradient(135deg, maroon, #8b4513);
          color: white;
          padding: 15px 40px;
          font-size: 1.3em;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
          margin: 20px 10px;
          transition: transform 0.3s ease;
        }
        
        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 15px rgba(0,0,0,0.2);
          color: white;
          text-decoration: none;
        }

        .location-card {
          background: #ffffff;
          border: 2px solid #e0e0e0;
          border-radius: 10px;
          padding: 20px;
          margin: 15px;
          display: inline-block;
          text-decoration: none;
          color: #333333;
          transition: all 0.3s ease;
          min-width: 250px;
        }
        
        .promo-code-badge {
          display: inline-block;
          background: maroon;
          color: white;
          font-weight: bold;
          font-size: 1.4em;
          letter-spacing: 0.08em;
          padding: 10px 24px;
          border-radius: 8px;
          margin: 10px 0;
        }

        .location-card:hover {
          border-color: maroon;
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          color: #333333;
          text-decoration: none;
          background: #f8f8f8;
        }
      `}</style>

      <div className="promotion-container">
        <div className="promotion-header">
          <h1 id="promotion-header" className="promotion-title">5% CASHBACK ON ALL ORDERS</h1>
          {/* <p className="promotion-subtitle">Get 5% cashback on every order</p>
          <p>Use promo code: <strong>SUSHIDON5</strong></p> */}
        </div>

        <div className="promotion-details">
          <h2 className="offer-text">🍚 Free Crispy Rice w/Spicy Tuna 🍣</h2>

          <div className="terms">
            <p>Spend $10 or more (before tax) and we'll add a Crispy Rice w/Spicy Tuna to your order — free.</p>
          </div>

          <div className="promo-code-badge">CrispyDon26</div>

          <div className="terms">
            <p>• Enter the code at checkout — the free crispy rice is added for you</p>
            <p>• Minimum $10 subtotal, before tax, not counting the free item</p>
            <p>• Valid for online orders only</p>
            <p>• One per order</p>
          </div>

          <a href="/valley-village/order" style={{color: 'white'}} className="cta-button">Order Online</a>
        </div>

        <div className="promotion-details">
          <div className="offer-text">🎉 5% Cashback 🎉</div>
          
          <div className="terms">
            {/* <p><strong>Promo Code:</strong> <span style={{color:'#d2691e'}}>SUSHIDON10</span></p> */}
            <p>• Valid for online orders only</p>
            {/* <p>• Minimum subtotal: $50</p> */}
            {/* <p>• One-time use per customer</p> */}
            {/* <p>• Cannot be combined with other discounts</p> */}
          </div>

          <a href="/order" style={{color: 'white'}} className="cta-button">Order Online</a>
        </div>

        <div className="locations-preview" id="locations">
          <h2>Available at Sushi Don</h2>
          <div className="locations-grid">
            {locationsMetadata.map(({ id, label, address, phone }) => (
              <div 
                key={id} 
                className="location-card"
                aria-label={`Contact ${label} location`}
              >
                <h3>{label}</h3>
                <p>{address[0]}<br/>{address[1]}</p>
                <p><strong>Call: <a href={`tel:${phone.replace(/[^0-9]/g, '')}`}>{phone}</a></strong></p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <RestaurantMap />
    </div>
  )
}